import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { UserService } from '../../core/services/core.user.service';
import { PollService } from '../../core/services/core.poll.service';

@Injectable()
export class TrackerTicklerService {

    constructor(
		private userService: UserService, 
        private pollService: PollService) {
	}

	public refreshPolling(section, refId: any = 0) {
		this.pollService.replace('tickler', section, refId, 'x');
	}

	public getPreferenceName(trackerId, queryId) {
		return `ti-tq-${ trackerId }-${ queryId }`;
	}

	// Remove the tickler from user preferences
	// Tickler param is the actual polling response
	public removeTickler(tickler) {
		return this.userService.preference.deletePreference(
			this.getPreferenceName(
				_.get(tickler, 'tracker', 0),
				tickler?.id
			)
		);
	}


	// Add the selected query to user preference as a tickler.
	// Query param is the query API object
	public addTickler(query) {
		const queryId = query?.id;
		return this.userService.preference.setPreference(
			this.getPreferenceName(
				_.get(query, 'tracker.id', 0),
				queryId				
			),
			queryId
		);
	}

	// ticklerAddQueries is the list of queries available to add
	// for the current tracker.  The list is only used in TIB.
	public getTicklerAddQueries(tracker, queries, ticklers) {		

		var trackerId = _.get(tracker, 'id', 0);
		if (!trackerId) return false;

		var t = _.find(queries, { id: trackerId });

		if (!t) return false;

		// Skip the custom query
		var savedQueries = _.filter(t.queries, function(q) {
			return (!q.id.toString().match(/(custom)/i));
		});

		// Skip queries already shown
		const existing = _.get(ticklers, 'queryTicklers', []);
		var addableQueries = savedQueries.filter(function(q) {
			var found = _.find(existing, { id: q.id });
			return (! found);
		});

		return addableQueries;
	}

	public getQueryTree(allTrackers, allQueries) {		
		const authorized = this.getAuthorizedTrackers(allTrackers);
        var tree = _.map(
            authorized,
            (t) => {
                return {
                    name: t.tracker_name,
                    id: t.tracker_id,
                    children: []
                };
            }
        );

        return tree.map((t) => {
            t.children = _.sortBy(
                _.filter(allQueries, (q) => { return q.tracker.id == t.id; }).map((q) => {
                    return {
                        name: q.queryName,
                        id: q.id,
                        tracker: t
                    };
                }),
                ['name']
            );
            return t;
        });
    }

    public isTrackerAdmin(project) {
        const value = _.get(project, 'rel.permissions.tracker', -1);
        return value >= 99;
    }

    public canReadTracker(tracker) {
        const value = _.get(tracker, 'access_level', -1);
        return value > 0;
    }

    public getAuthorizedTrackers(project) {
        const allTrackers = _.get(project, 'rel.trackers', []);
        if (this.isTrackerAdmin(project)) {
            return allTrackers;
        }

        return _.filter(
            allTrackers, this.canReadTracker
        );
    }

	public getDisplayTicklers(ticklers, max = 5): any {
		return _.sortBy(
			ticklers,
			['trackerName', 'queryName']
		).slice(0, max);
	}

	public addUrlToTicklers(ticklers): any {
		return _.map(
			ticklers,
			(tickler) => {
				tickler.url = '/project/' + tickler.project + '/tracker/' + tickler.tracker + '/browse?query=' + tickler.id
				return tickler;
			}
		);
	}

	public getTicklerCountMap(ticklers): any {
		return _.reduce(
			ticklers,
			(carry, item) => {
				carry[item.id] = item.count;
				return carry;
			},
			{}
		);
	}
}
